import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId, useLanguageCode } from '@mews-commander/core';

export const useGetDigitalKeyConfigurationStatus = () => {
    const languageCode = useLanguageCode();
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery('digitalKeyConfiguration', 'getStatus', {
        languageCode,
        enterpriseId,
    });
};
